import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const EquipmentManagementEntry = () => {
  useModuleRedirect("equipment-management");
  return null;
};

export default EquipmentManagementEntry;
